import React, { useEffect, useMemo, useState } from "react";
import Navbar from "./Navbar.js";
import Sidebar from "./SIdebar.js";
import Products from "../screens/Products.js";
import UserDashboard from "../screens/UserDashboard.js";
import AddProduct from "../screens/AddProduct.js";
import Breadcrumb from "./Breadcrumb"; // Import Breadcrumb
import {
  FaHome,
  FaBox,
  FaBalanceScale,
  FaBuilding,
  FaUserTie,
  FaTags,
  FaLocationArrow,
  FaUsers,
  FaRecycle,
  FaIndustry,
  FaRegCreditCard,
  FaShopify,
  FaFileInvoiceDollar,
  FaExchangeAlt,
  FaTruck,
  FaReceipt,
  FaArrowsAltV,
  FaWarehouse,
  FaHandHoldingUsd,
  FaClipboardCheck,
  FaArrowCircleDown,
  FaShoppingCart,
  FaPeopleCarry,
  FaCreditCard,
} from "react-icons/fa"; // Import icons
import { BsRepeat, BsArrowDownLeft, BsArrowUpRight } from "react-icons/bs";
import { LiaFileInvoiceDollarSolid } from "react-icons/lia";
import { MdOutlinePayments } from "react-icons/md";
import { IoReceiptOutline} from "react-icons/io5";
import Units from "../screens/Units";
import AddUnit from "../screens/AddUnit";
import Organizations from "../screens/Organizations";
import AddOrganization from "../screens/AddOrganization";
import Customers from "../screens/Customers";
import AddCustomer from "../screens/AddCustomer";
import ProductCateogry from "../screens/ProductCategory.js";
import AddProductCategory from "../screens/AddProductCategory.js";
import Location from "../screens/Location.js";
import AddLocation from "../screens/AddLocations.js";
import Users from "../screens/Users.js";
import AddUser from "../screens/AddUser.js";
import ProductBatch from "../screens/ProductBatch.js";
import { useNavigate } from "react-router-dom";
import OrderCycle from "../screens/OrderCycle.js";
import CreateNewOrderCycle from "../screens/CreateNewOrderCycle.js";
import { useCallback } from "react";
import OrderRequest from "../screens/OrderRequest.js";
import { jwtDecode } from "jwt-decode";
import UserProfile from "../screens/UserProfile.js";
import SalesOrderInvoicing from "../screens/SalesOrderInvoicing.js";
import SalesOrders from "../screens/SalesOrders.js";
import SalesInvoice from "../screens/Invoice.js";
import TransferOrders from "../screens/TransferOrder.js";
import AddProductionBatch from "../screens/AddProductionBatch.js";
import AddTransferOrder from "../screens/AddTransferOrder.js";
import AddOrderRequest from "../screens/AddOrderRequest.js";
import AddLocationCategory from "../screens/AddLocationCategory.js";
import TransportOrders from "../screens/TransportOrder.js";
import AddTransportOrder from "../screens/AddTransportOrder.js";
import TransferOrderReceipts from "../screens/TransferOrderReceipts.js";
import AddAdjustmentCategory from "../screens/AddAdjustmentCategory.js";
import PaymentReceipts from "../screens/PaymentReceipts.js";
import AddPaymentReceipts from "../screens/AddPaymentReceipts.js";
import Settlements from "../screens/Settlements.js";
import AddSettelments from "../screens/AddSettelments.js";
import StockAdjustment from "../screens/StockAdjustment.js";
import AddStockAdjustment from "../screens/AddStockAdjustment.js";
import StockView from "../screens/StockView.js";
import Settings from "../screens/Settings.js";
import DispatchedStockOnLoan from "../screens/DispatchedStockOnLoan.js";
import AddDispatchedStockOnLoan from "../screens/AddDispatchStockOnLoan.js";
import ReceivedStockOnLoan from "../screens/ReceivedStockOnLoan.js";
import AddReceivedStockOnLoan from "../screens/AddReceivedStockOnLoan.js";
import IncomingStockOnLoan from "../screens/IncomingStockOnLoan.js";
import AddSupplier from "../screens/AddSupplier.js";
import AddPurchaseOrder from "../screens/AddPurchaseOrder.js";
import AddGRN from "../screens/AddGRN.js";
import GoodReceiptNote from "../screens/GoodReceiptNote.js";
import PurchaseOrders from "../screens/PurchaseOrders.js";
import Suppliers from "../screens/Suppliers.js";
import StockMovementView from "../screens/StockMovementView.js";
import CreditNote from "../screens/CreditNote.js";
import AddCreditNote from "../screens/AddCreditNote.js";
import Cluster from "../screens/Clusters.js";
import AddCluster from "../screens/AddClusters.js";
import PurchasingInvoice from "../screens/PurchasingInvoice.js";
import CategoryDashboard from "./CategoryDashboard.js";
import DebitNote from "../screens/debitNote";
import AddDebitNote from "../screens/AddDebitNote.js";
import PurchaseOrderSettlements from "../screens/PurchaseOrderSettlements.js";
import AddPurchaseSettlement from "../screens/AddPurchaseSettlement.js";
import SupplierPayments from "../screens/SupplierPayments.js";
import AddSupplierPayments from "../screens/AddSupplierPayments.js";
import ReimbursementPage from "../screens/ReimbursementPage";
import IOUPage from "../screens/IOUPage";
import CashBookCategory from "../screens/CashbookCategory";
import CashBook from "../screens/CashBook";
import TransactionPage from "../screens/TransactionPage.js";
import ClaimPage from "../screens/ClaimPage.js";
import IOUSettlementPage from "../screens/IOUSettlementPage";

const rolePermissions = {  
  products: ["Main Admin", "Company Admin", "Accountant", "Farm User"],
  clusters: ["Main Admin", "Company Admin", "Farm User"],
  users: ["Main Admin", "Company Admin"],
  organizations: ["Main Admin"],
  payment: [
    "Main Admin",
    "Company Admin",
    "Outlet User",
    "Farm User",
    "Accountant",
  ],
    "cashbook-category": ["Company Admin", "Accountant"],
    cashbook: ["Company Admin", "Accountant", ],
    reimbursement: ["Company Admin", "Accountant" ,"Farm User", "Outlet User"],
    claim : ["Company Admin", "Accountant"],
    iou: ["Company Admin", "Accountant","Farm User", "Outlet User"],
    transaction:  ["Company Admin", "Accountant","Farm User", "Outlet User"],
    "iou-settlement": ["Company Admin", "Accountant","Farm User", "Outlet User"],
  units: ["Main Admin"],
  settelments: [
    "Main Admin",
    "Company Admin",
    "Outlet User",
    "Farm User",
    "Accountant",
  ],
  PurchaseOrderSettlements: [
    "Main Admin",
    "Company Admin",
    "Outlet User",
    "Farm User",
    "Accountant",
  ],
  customers: ["Main Admin", "Company Admin"],
  locations: ["Main Admin", "Company Admin"],
  suppliers: ["Main Admin", "Company Admin"],
  "product-categories": ["Main Admin", "Company Admin"],
  "purchase-orders": [
    "Main Admin",
    "Company Admin",
    "Outlet User",
    "Accountant",
    "Farm User",
  ],
  "goods-receipt-note": [
    "Main Admin",
    "Company Admin",
    "Outlet User",
    "Accountant",
    "Farm User",
  ],
  "transfer-orders": [
    "Company Admin",
    "Accountant",
    "Farm User",
  ],
  "production-batch": ["Main Admin", "Company Admin", "Farm User", "Accountant"],
  "purchase-invoices": [
    "Main Admin",
    "Company Admin",
    "Outlet User",
    "Accountant",
    "Farm User",
  ],
};

const DashboardLayout = ({ setIsAuthenticated }) => {
  const [activeContent, setActiveContent] = useState({
    content: "user-dashboard",
    state: {},
  });
  const [isSidebarOpen, setSidebarOpen] = useState(true);
  const [breadcrumbPaths, setBreadcrumbPaths] = useState([
    {
      name: "Home",
      content: "user-dashboard",
      icon: <FaHome />,
      isActive: true,
    }
  ]);
  const navigate = useNavigate();
  const username = sessionStorage.getItem("username");

  useEffect(() => {
    const validateToken = () => {
      const token = sessionStorage.getItem("token");
      if (token) {
        try {
          const decodedToken = jwtDecode(token);
          if (Date.now() >= decodedToken.exp * 1000) {
              sessionStorage.clear();
            navigate("/login");
            return false;
          }
          return true;
        } catch (error) {
          console.error("Invalid token:", error);
            sessionStorage.clear();
          navigate("/login");
          return false;
        }
      } else {
        navigate("/login");
        return false;
      }
    };
    const interval = setInterval(validateToken, 60 * 1000);
    if (!validateToken()) return;
    return () => clearInterval(interval);
  }, [navigate]);

  const menuHierarchy = useMemo(
    () => ({
      "master-data": { parent: null, name: "Master Data", icon: <FaTags /> },
      products: { parent: "master-data", name: "Product", icon: <FaBox /> },
      units: { parent: "master-data", name: "Unit", icon: <FaBalanceScale /> },
      organizations: { parent: "master-data", name: "Organization", icon: <FaBuilding /> },
      customers: { parent: "master-data", name: "Customer", icon: <FaUserTie /> },
      suppliers: { parent: "master-data", name: "Supplier", icon: <FaPeopleCarry /> },
      "product-categories": { parent: "master-data", name: "Category", icon: <FaTags /> },
      locations: { parent: "master-data", name: "Location", icon: <FaLocationArrow /> },
      users: { parent: "master-data", name: "User", icon: <FaUsers /> },
      clusters: { parent: "master-data", name: "Clusters", icon: <FaIndustry /> },
      production: { parent: null, name: "Production", icon: <FaIndustry /> },
      "production-batch": { parent: "production", name: "Production Batch", icon: <FaRecycle /> },
      "stock-adjustment": { parent: "production", name: "Stock Adjustment", icon: <FaArrowsAltV /> },
      orders: { parent: null, name: "Orders", icon: <FaShopify /> },
      "order-cycle": { parent: "orders", name: "Order Cycle", icon: <BsRepeat /> },
      "order-request": { parent: "orders", name: "Order Requests", icon: <BsArrowDownLeft /> },
      "sales-orders": { parent: "orders", name: "Sales Orders", icon: <BsArrowUpRight /> },
      "transfer-orders": { parent: "orders", name: "Transfer Orders", icon: <FaExchangeAlt /> },
      "transfer-order-receipts": { parent: "orders", name: "Transfer Order Receipt", icon: <FaReceipt /> },
      "transport-orders": { parent: "orders", name: "Transport Orders", icon: <FaTruck /> },
      "stock-on-loan": { parent: null, name: "Stock On Loan", icon: <FaHandHoldingUsd /> },
      "dispatched-stock-on-loan": { parent: "stock-on-loan", name: "Dispatched", icon: <FaClipboardCheck /> },
      //"received-stock-on-loan": { parent: "stock-on-loan", name: "Received", icon: <FaHandHolding /> },
      "incoming-stock-on-loan": { parent: "stock-on-loan", name: "Incoming", icon: <FaArrowCircleDown /> },
      invoices: { parent: null, name: "Sales", icon: <LiaFileInvoiceDollarSolid /> },
      // --- CHANGE 1: Standardized the key ---
      "sales-invoices": { parent: "invoices", name: "Sales Invoices", icon: <LiaFileInvoiceDollarSolid /> },
      "credit-note": { parent: "invoices", name: "Credit Notes", icon: <FaCreditCard /> },
      payment: { parent: "invoices", name: "Receipts", icon: <MdOutlinePayments /> },
      settelments: { parent: "invoices", name: "Settlements", icon: <IoReceiptOutline /> },
      purchasing: { parent: null, name: "Procurement", icon: <FaShoppingCart /> },
      "purchase-orders": { parent: "purchasing", name: "Purchase Orders", icon: <FaShoppingCart /> },
      "goods-receipt-note": { parent: "purchasing", name: "Goods Receipt", icon: <FaReceipt /> },
      "purchase-invoices": { parent: "purchasing", name: "Purchasing Invoice", icon: <FaFileInvoiceDollar /> },
      "SupplierPayments": { parent: "purchasing", name: "Supplier Payments", icon: <FaHandHoldingUsd /> },
      "debit-note" : { parent: "purchasing", name: "Debit Notes", icon: <FaRegCreditCard   /> },
      "PurchaseOrderSettlements": { parent: "purchasing", name: "Settlements", icon: <IoReceiptOutline /> },
      reports: { parent: null, name: "Reports", icon: <FaWarehouse /> },
      "stock-view": { parent: "reports", name: "Stock View", icon: <FaWarehouse /> },
      "stock-movement": { parent: "reports", name: "Stock Movements", icon: <FaArrowsAltV /> },
      // settings: { parent: null, name: "Settings", icon: <IoSettings /> },
      "add-product": { parent: "products", name: "Add Product" },
      "add-unit": { parent: "units", name: "Add Unit" },
      "add-organization": { parent: "organizations", name: "Add Organization" },
      "add-customer": { parent: "customers", name: "Add Customer" },
      "add-supplier": { parent: "suppliers", name: "Add Supplier" },
      "add-product-categories": { parent: "product-categories", name: "Add Product Category" },
      "add-location-categories": { parent: "product-categories", name: "Add Location Category" },
      "add-adjustment-categories": { parent: "product-categories", name: "Add Adjustment Category" },
      "add-location": { parent: "locations", name: "Add Location" },
      "add-user": { parent: "users", name: "Add User" },
      "add-cluster": { parent: "clusters", name: "Add Cluster" },
      "add-production-batch": { parent: "production-batch", name: "Add Production Batch" },
      "add-stock-adjustment": { parent: "stock-adjustment", name: "Add Stock Adjustment" },
      "add-order-cycle": { parent: "order-cycle", name: "Add Order Cycle" },
      "sales-order-invoicing": { parent: "order-request", name: "Sales Order Invoicing" },
      "add-sales-order": { parent: "sales-orders", name: "Add Sales Order" },
      "add-transfer-order": { parent: "transfer-orders", name: "Add Transfer Order" },
      "add-transport-order": { parent: "transport-orders", name: "Add Transport Order" },
      "add-order-request": { parent: "order-request", name: "Add Order Request" },
      "add-dispatch-stock-on-loan": { parent: "dispatched-stock-on-loan", name: "Add Dispatched Stock" },
      "add-received-stock-on-loan": { parent: "received-stock-on-loan", name: "Add Received Stock" },
      "add-payment-Receipts": { parent: "payment", name: "Add Payment Receipts" },
      "add-credit-note": { parent: "credit-note", name: "Add Credit Note" },
      "add-debit-note" : { parent: "debit-note", name: "Add Debit Note"},
      "add-settelments": { parent: "settelments", name: "Add Settlements" },
      "add-purchase-orders": { parent: "purchase-orders", name: "Add Purchase Order" },
      "add-grn": { parent: "goods-receipt-note", name: "Add GRN" },
      "add-PurchaseOrderSettlements": { parent: "PurchaseOrderSettlements", name: "Add Settlements" },
      "add-supplier-payments": { parent: "SupplierPayments", name: "Add Supplier Payments" },
        "cashbook-category": {
            parent: "master-data",
            name: "CashBook Category",
            icon: <FaHandHoldingUsd/>,
        },
        "petty-cash": {
          parent: null,
            name: "Petty Cash",
            icon: <FaHandHoldingUsd/>,
        },
        "cashbook": {
            parent: "petty-cash",
            name: "CashBook",
            icon: <FaHandHoldingUsd />,
        },
        "claim": {
          parent: "petty-cash",
            name: "Claim",
            icon: <FaCreditCard/>,
        },
        "reimbursement": {
          parent: "petty-cash",
            name: "Reimbursement",
            icon: <FaExchangeAlt/>,
        },
        "iou-settlement": {
            parent: "petty-cash",
            name: "IOU Settlement",
            icon: <FaExchangeAlt/>,
        },
        "iou": {
          parent: "petty-cash",
            name: "IoU",
            icon: <FaReceipt/>,
        },
        "transaction": {
          parent: "petty-cash",
            name: "Transaction",
            icon: <FaFileInvoiceDollar />,

        }
    }),
    []
  );

  const menuStructure = useMemo(() => {
    const userRole = sessionStorage.getItem("role");
    const structure = {};
    Object.keys(menuHierarchy).forEach((key) => {
      if (!menuHierarchy[key].parent) {
        structure[key] = { ...menuHierarchy[key], children: [] };
      }
    });
    Object.keys(menuHierarchy).forEach((key) => {
      const item = menuHierarchy[key];
      if (item.parent && structure[item.parent] && item.icon) {
        const allowedRoles = rolePermissions[key];
        if (!allowedRoles || allowedRoles.includes(userRole)) {
          structure[item.parent].children.push({ id: key, ...item });
        }
      }
    });
    Object.keys(structure).forEach((parentKey) => {
      structure[parentKey].children.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
    });
    return structure;
  }, [menuHierarchy]);

  const getContentName = useCallback(
    (content) => menuHierarchy[content]?.name || "Home",
    [menuHierarchy]
  );

  const getContentIcon = useCallback(
    (content) => menuHierarchy[content]?.icon || <FaHome />,
    [menuHierarchy]
  );

  const updateBreadcrumbPaths = useCallback(
    (content) => {
      if (content === "user-dashboard") {
        setBreadcrumbPaths([
          {
            name: "Home",
            content: "user-dashboard",
            icon: <FaHome />,
            isActive: true,
          },
        ]);
        return;
      }
      if (content === "settings") {
        setBreadcrumbPaths([
          {
            name: getContentName(content),
            content,
            icon: getContentIcon(content),
            isActive: true,
          },
        ]);
        return;
      }
      const newPath = {
        name: getContentName(content),
        content,
        icon: getContentIcon(content),
        isActive: true,
      };
      const hierarchy = menuHierarchy[content];
      if (hierarchy && hierarchy.parent) {
        const parentPath = {
          name: getContentName(hierarchy.parent),
          content: hierarchy.parent,
          icon: getContentIcon(hierarchy.parent),
          isActive: false,
        };
        setBreadcrumbPaths((prevPaths) => [prevPaths[0], parentPath, newPath]);
      } else {
        setBreadcrumbPaths((prevPaths) => [prevPaths[0], newPath]);
      }
    },
    [getContentName, getContentIcon, menuHierarchy]
  );

  const handleContentChange = useCallback(
    (content, state = {}) => {
      updateBreadcrumbPaths(content);
      setActiveContent({ content, state });
    },
    [updateBreadcrumbPaths]
  );

  const toggleSidebar = () => setSidebarOpen(!isSidebarOpen);

  const renderContent = useCallback(() => {
    if (menuStructure[activeContent.content]) {
      const category = menuStructure[activeContent.content];
      return (
        <CategoryDashboard
          title={category.name}
          items={category.children}
          onNavigate={handleContentChange}
        />
      );
    }

    switch (activeContent.content) {
      case "user-dashboard": return <UserDashboard />;
      case "user-profile": return <UserProfile />;
      case "products": return <Products onAddProductClick={() => handleContentChange("add-product")} />;
      case "add-product": return <AddProduct />;
      case "units": return <Units onAddUnitClick={() => handleContentChange("add-unit")} />;
      case "add-unit": return <AddUnit />;
      case "organizations": return <Organizations onAddOrganizationClick={() => handleContentChange("add-organization")} />;
      case "add-organization": return <AddOrganization />;
      case "customers": return <Customers onAddCustomerClick={() => handleContentChange("add-customer")} />;
      case "add-customer": return <AddCustomer />;
      case "suppliers": return <Suppliers onAddSupplierClick={() => handleContentChange("add-supplier")} />;
      case "add-supplier": return <AddSupplier />;
      case "product-categories": return <ProductCateogry onAddProductCategoryClick={() => handleContentChange("add-product-categories")} onAddLocationCategoryClick={() => handleContentChange("add-location-categories")} onAddAdjustmentCategoryClick={() => handleContentChange("add-adjustment-categories")} />;
      case "add-product-categories": return <AddProductCategory />;
      case "add-location-categories": return <AddLocationCategory />;
      case "add-adjustment-categories": return <AddAdjustmentCategory />;
      case "locations": return <Location onAddLocationClick={() => handleContentChange("add-location")} />;
      case "add-location": return <AddLocation />;
      case "users": return <Users onAddUserClick={() => handleContentChange("add-user")} />;
      case "add-user": return <AddUser />;
      case "production-batch": return <ProductBatch onAddProductBatchClick={() => handleContentChange("add-production-batch")} />;
      case "add-production-batch": return <AddProductionBatch />;
      case "stock-adjustment": return <StockAdjustment onAddStockAdjustmentClick={() => handleContentChange("add-stock-adjustment")} />;
      case "add-stock-adjustment": return <AddStockAdjustment />;
      case "order-cycle": return <OrderCycle onAddOrderCycleClick={() => handleContentChange("add-order-cycle")} />;
      case "add-order-cycle": return <CreateNewOrderCycle />;
      case "order-request": return <OrderRequest onInvoicingClick={(orderRequest) => handleContentChange("sales-order-invoicing", { orderRequestCode: orderRequest.orderRequestCode, orderRequest, })} onAddOrderRequestClick={() => handleContentChange("add-order-request")} />;
      case "add-order-request": return <AddOrderRequest />;
      case "sales-order-invoicing": return <SalesOrderInvoicing orderRequestCode={activeContent.state.orderRequestCode} orderRequest={activeContent.state.orderRequest} />;
      case "sales-orders": return <SalesOrders onAddSalesOrderClick={() => handleContentChange("add-sales-order")} />;
      case "transfer-orders": return <TransferOrders onAddTransferOrderClick={() => handleContentChange("add-transfer-order")} />;
      case "add-transfer-order": return <AddTransferOrder />;
      case "transfer-order-receipts": return <TransferOrderReceipts />;
      case "transport-orders": return <TransportOrders onAddTransportOrderClick={() => handleContentChange("add-transport-order")} />;
      case "add-transport-order": return <AddTransportOrder />;
      case "dispatched-stock-on-loan": return <DispatchedStockOnLoan onAddDispatchedStockOnLoanClick={() => handleContentChange("add-dispatch-stock-on-loan")} />;
      case "add-dispatch-stock-on-loan": return <AddDispatchedStockOnLoan />;
      case "incoming-stock-on-loan": return <IncomingStockOnLoan onAddReceivedStockOnLoanClick={(stockOnLoan) => handleContentChange("add-received-stock-on-loan", { dispatchedStockOnLoanCode: stockOnLoan.dispatchedStockOnLoanCode, stockOnLoan, })} />;
      case "received-stock-on-loan": return <ReceivedStockOnLoan onAddReceivedStockOnLoanClick={() => handleContentChange("add-received-stock-on-loan")} />;
      case "add-received-stock-on-loan": return <AddReceivedStockOnLoan dispatchedStockOnLoanCode={activeContent.state.dispatchedStockOnLoanCode} stockOnLoan={activeContent.state.stockOnLoan} />;
      case "stock-view": return <StockView />;
      case "stock-movement": return <StockMovementView />;
      case "payment": return <PaymentReceipts onAddPaymentClick={() => handleContentChange("add-payment-Receipts")} />;
      case "add-payment-Receipts": return <AddPaymentReceipts />;
      case "credit-note": return <CreditNote onAddCreditNoteClick={() => handleContentChange("add-credit-note")} />;
      case "add-credit-note": return <AddCreditNote />;
      case "settelments": return <Settlements onAddSettlementClick={() => handleContentChange("add-settelments")} />;
      case "add-settelments": return <AddSettelments />;
      case "purchase-orders": return <PurchaseOrders onAddPurchaseOrderClick={() => handleContentChange("add-purchase-orders")} onAddGRNClick={(order) => handleContentChange("add-grn", { orderId: order.id, order, })} />;
      case "add-purchase-orders": return <AddPurchaseOrder />;
      case "add-grn": return <AddGRN orderId={activeContent.state.orderId} order={activeContent.state.order} />;
      case "goods-receipt-note": return <GoodReceiptNote />;
      case "purchase-invoices": return <PurchasingInvoice />;
      case "sales-invoices": return <SalesInvoice />;
      case "settings": return <Settings />;
      case "clusters": return <Cluster onAddClusterClick={() => handleContentChange("add-cluster")} />;
      case "add-cluster": return <AddCluster />;
      case "debit-note": return <DebitNote onAddDebitNoteClick={() => handleContentChange("add-debit-note")} />;
      case "add-debit-note": return <AddDebitNote />;
      case "PurchaseOrderSettlements": return <PurchaseOrderSettlements onAddSettlementClick={() => handleContentChange("add-PurchaseOrderSettlements")} />;
      case "add-PurchaseOrderSettlements": return <AddPurchaseSettlement />;
      case "SupplierPayments": return <SupplierPayments onAddPaymentClick={() => handleContentChange("add-supplier-payments")} />;
      case "add-supplier-payments": return <AddSupplierPayments />;
        case "cashbook-category":return <CashBookCategory />;
        case "cashbook":return <CashBook {...activeContent.state}/>;
        case "reimbursement": return <ReimbursementPage/>;
        case "iou-settlement":return <IOUSettlementPage />;
        case "claim": return <ClaimPage />;
        case "iou": return <IOUPage/>;
        case "transaction": return <TransactionPage handleContentChange={handleContentChange}/>;
      default:
        return <div>Select a content from the sidebar</div>;
    }
  }, [activeContent, handleContentChange, menuStructure]);

  return (
    <div className="flex min-h-screen bg-gray-100">
      <div
        className={`${
          isSidebarOpen ? "w-68" : "w-0"
        } transition-all duration-300 bg-gray-800 overflow-y-auto h-screen fixed top-0 left-0`}
      >
        <Sidebar onContentChange={handleContentChange} onLogout={""} />
      </div>
      <div
        className={`flex-1 flex flex-col transition-margin duration-300`}
        style={{
          marginLeft: isSidebarOpen ? "16rem" : "0",
          width: isSidebarOpen ? "calc(100% - 16rem)" : "100%",
        }}
      >
        <Navbar
          toggleSidebar={toggleSidebar}
          isSidebarOpen={isSidebarOpen}
          username={username}
          navigateToProfile={() => handleContentChange("user-profile")}
          onLogout={""}
        />
        <main className="flex-1 p-6 bg-gray-100 overflow-auto">
          <Breadcrumb paths={breadcrumbPaths} onClick={handleContentChange} />
          {renderContent()}
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;